export default __webpack_public_path__ + "static/media/gift-yellow-large.da23da8c.svg";